import { render, staticRenderFns } from "./mainContainer.vue?vue&type=template&id=4536d2fc&scoped=true"
import script from "./mainContainer.vue?vue&type=script&lang=js"
export * from "./mainContainer.vue?vue&type=script&lang=js"
import style0 from "./mainContainer.vue?vue&type=style&index=0&id=4536d2fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4536d2fc",
  null
  
)

export default component.exports